import { useMemo } from 'react';

import type { AnalyticsDataPoint } from '../components/ChartContainer';

export function useAggregatedMetrics(data: AnalyticsDataPoint[]) {
    return useMemo(() => {
        const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
        const volume = data.reduce((sum, item) => sum + (item.volume || 0), 0);
        return { total, volume };
    }, [data]);
}


